// ======================================================================
// File Name       : CourseHistorySearchInput
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { VALIDATE_TYPE, RETURN_MAX_NUM } from '../../../constants/index';
import RenderField from '../../../utils/ReduxFormUtils';
import CustomButton from '../../button/CustomButton';

class CourseHistorySearchInput extends React.Component {
  render() {
    const {
      searchInfo,
      onSearchCourse,
    } = this.props;
    let courseName = '';
    if (searchInfo && searchInfo.values && searchInfo.values.courseName) {
      courseName = searchInfo.values.courseName;
    }
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchCourse();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="padding-top-10 margin-bottom-15">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コース名
              </Col>
              <Col sm={7}>
                <RenderField
                  type="text"
                  name="courseName"
                  label="レポート名"
                  maxLength="256"
                  value={courseName}
                />
              </Col>
            </Form.Group>
          </Col>
        </Form>
        <Col sm={12} className="text-center margin-bottom-15">
          <CustomButton
            btnStyle="btn btn-primary btn-96"
            handleClick={onSearchCourse}
            text="検索"
            iconClass="bi bi-search"
          />
        </Col>
      </div>
    );
  }
}

export default CourseHistorySearchInput;
